"use clinet";

import { ProfileUpsellCard } from "@components/molecules/profileUpsellCard";
import { FEATURES } from "@features/features-list";
import { SubscriptionModule } from "@features/subscription/model";
import { UpsellModule } from "@features/upsell/model";
import clsx from "clsx";
import { useUnit } from "effector-react";

interface UpsellsStatusesProps {
    className: string;
}

export const UpsellsStatuses = ({ className }: UpsellsStatusesProps) => {
    const SubscriptionsContract = FEATURES.getByType<SubscriptionModule>(SubscriptionModule).getContract();
    const $subscriptions = useUnit(SubscriptionsContract.stores.$subscriptions);

    const UpsellContarct = FEATURES.getByType<UpsellModule>(UpsellModule).getContract();
    const $isPurchasdUpsellPending = useUnit(UpsellContarct.stores.$isPurchasdUpsellPending);
    const $isUpsell1Purchased = useUnit(UpsellContarct.stores.$isUpsell1Purchased);
    const $isUpsell2Purchased = useUnit(UpsellContarct.stores.$isUpsell2Purchased);

    const handlerClick = () => sessionStorage.setItem("prevProfileUrl", window.location.pathname);

    if ($isPurchasdUpsellPending) return <div className={className}>Loading...</div>;
    if ($subscriptions.length === 0 || $subscriptions[0].platform.code !== "solidgate") return null;

    return (
        <div className={clsx("pb-6 flex flex-col gap-6 text-[18px] leading-[22px] font-bold", className)}>
            {($isUpsell1Purchased || $isUpsell2Purchased) && (
                <div className="flex flex-col gap-3">
                    <p className="text-blue-100">In your package</p>
                    {$isUpsell2Purchased && (
                        <ProfileUpsellCard
                            text="Personal boost pack"
                            href="https://glowing-glue-c00.notion.site/Tixu-Personal-Boost-Pack-2220f29efeb680c8824be792faaf600f"
                            status="View"
                            onClick={handlerClick}
                        />
                    )}
                    {$isUpsell1Purchased && (
                        <ProfileUpsellCard
                            text="31,000 AI prompts pack"
                            href="https://glowing-glue-c00.notion.site/Tixu-The-Ultimate-Al-Power-Pack-2220f29efeb680bb9f1ff5185ac84f40"
                            status="View"
                            onClick={handlerClick}
                        />
                    )}
                </div>
            )}

            {(!$isUpsell1Purchased || !$isUpsell2Purchased) && (
                <div className="flex flex-col gap-3">
                    <p className="text-blue-100">Available</p>
                    {!$isUpsell2Purchased && (
                        <ProfileUpsellCard
                            text="Personal boost pack"
                            href="/upsell/2"
                            status="Buy"
                            onClick={handlerClick}
                        />
                    )}
                    {!$isUpsell1Purchased && (
                        <ProfileUpsellCard
                            text="31,000 AI prompts pack"
                            href="/upsell/1"
                            status="Buy"
                            onClick={handlerClick}
                        />
                    )}
                </div>
            )}
        </div>
    );
};
